import React from 'react';
import {
  arrayOf,
  string,
  shape,
} from 'prop-types';
import _ from 'lodash';
import { Heading } from 'components/common';
import { FaqContextualPanel, questionWithQuestionMark } from 'components/FAQ/FaqContextualContainer';
import YrrColumn from './YrrColumn';
import RewardSlickPanel from './RewardSlickPanel';

import './BenefitsSection.scss';

const BenefitsSection = ({
  yearRoundOffers,
  additionalOffers,
  faqs,
  labels,
}) => (
  <div className="benefits-section">
    <div className="container-wrapper">
      <div className="row-wrapper">
        <div className="title">
          <Heading as="h2">
            {labels.heading}
          </Heading>
        </div>
        <div className="content">
          <div className="row-wrapper">
            {yearRoundOffers.length > 0 && (
              <div className="yrr-questions-wrapper">
                <div className="row-wrapper">
                  <div className="yrr-column-wrapper">
                    <YrrColumn
                      yrrs={yearRoundOffers}
                      labels={labels}
                    />
                  </div>
                  {faqs && (
                  <div className="questions-wrapper">
                    <FaqContextualPanel
                      sidebar
                      questionRender={questionWithQuestionMark}
                      {...faqs}
                    />
                  </div>
                  )}
                </div>
              </div>
            )}
            {!_.isEmpty(additionalOffers) && (
              <div className="additional-rewards-panel-wrapper">
                <div className="additional-rewards-panel">
                  <Heading as="h3">
                    {labels.yearRoundBenefits}
                  </Heading>
                  <div className="reward-slick-panel-wrapper">
                    <RewardSlickPanel
                      rewards={additionalOffers}
                      labelOption={labels.offerLabel}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

BenefitsSection.defaultProps = {
  yearRoundOffers: [],
  additionalOffers: [],
  labels: {},
  faqs: {},
};

BenefitsSection.propTypes = {
  yearRoundOffers: arrayOf(
    shape({
      name: string,
      cashRebate: shape({
        value: string,
        tooltip: string,
      }),
      airmiles: shape({
        value: string,
        tooltip: string,
      }),
    })
  ),
  additionalOffers: arrayOf(shape({})),
  faqs: shape({}),
  labels: shape({
    title: string,
    yearRoundBenefits: string,
  }),
};

export default BenefitsSection;
